/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
// import $ from "jquery";
// import OnScreen from "onscreen";
// import SwitchGrid from "./module/switchGrid";
// import FixMenu from "./module/fixMenu";
// import FlexSticky from "./module/flexSticky";
var _letters = _letters || {};

var html = document.querySelector("html");
var body = document.querySelector("body");
document.addEventListener("DOMContentLoaded", function () {
  window._letters = _letters;
  html.classList.add("is-page-init"); //product slider

  if (document.querySelector(".js-product-slider")) {
    var productSwiper = new Swiper(".js-product-slider", {
      // Optional parameters
      direction: "horizontal",
      loop: true,
      threshold: 10,
      pagination: {
        el: ".swiper-pagination"
      },
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // And if we need scrollbar
      scrollbar: {
        el: ".swiper-scrollbar"
      }
    });
  }
});
/******/ })()
;